import { Phone } from "lucide-react";
import { useState, type FormEvent } from "react";

import { trpc } from "../../lib/trpc";

/**
 * I recapiti che i clienti leggono nella sezione Supporto.
 *
 * Stanno in banca dati proprio per essere cambiati da qui: un numero di telefono che cambia
 * non deve costringere a ripubblicare l'applicazione.
 */
export function RecapitiConsole() {
  const utils = trpc.useUtils();
  const recapiti = trpc.platform.recapiti.useQuery();
  const salva = trpc.platform.salvaRecapiti.useMutation({
    onSuccess: () => void utils.platform.recapiti.invalidate(),
  });
  const [salvato, setSalvato] = useState(false);

  async function scrivi(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const dati = new FormData(event.currentTarget);
    setSalvato(false);
    try {
      await salva.mutateAsync({ email: String(dati.get("email")), telefono: String(dati.get("telefono")) });
      setSalvato(true);
    } catch {
      // L'errore resta nella mutazione e la schermata lo mostra sotto al modulo.
    }
  }

  return (
    <section className="section-block">
      <div className="section-heading">
        <div><p className="eyebrow">Assistenza</p><h2>Recapiti mostrati ai clienti</h2></div>
      </div>
      <form className="console-form" onSubmit={scrivi}>
        <p className="console-form__intro">
          Quello che i clienti vedono nel Supporto, alla voce del problema urgente. Il telefono si mostra solo
          se c'e: lasciato vuoto, resta soltanto l'email.
        </p>
        <label>
          <span>Email</span>
          <input name="email" type="email" required defaultValue={recapiti.data?.email ?? ""} />
        </label>
        <label>
          <span><Phone size={15} aria-hidden="true" /> Telefono</span>
          <input name="telefono" defaultValue={recapiti.data?.telefono ?? ""} placeholder="+39 ..." maxLength={40} />
        </label>
        {salva.error && <p className="form-error">{salva.error.message}</p>}
        {salvato && <p className="support-form__ok" role="status">Recapiti aggiornati.</p>}
        <div className="form-actions">
          <button className={`button button--primary${salva.isPending ? " button--saving" : ""}`} disabled={salva.isPending}>
            {salva.isPending ? "Salvataggio..." : "Salva i recapiti"}
          </button>
        </div>
      </form>
    </section>
  );
}
